<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>老师管理</Breadcrumb-item>
        <Breadcrumb-item>奖惩机制</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div>
        <quillEditor v-model="formData.content" ref="myQuillEditor" :options="editorOption" @change="textChange"></quillEditor>
        <el-upload class="upload-demo" :action="action" :before-upload='beforeUpload'
                   :headers="headers" :accept="acceptType" :on-success='upScuccess' ref="upload" style="display:none">
          <el-button size="small" type="primary" id="imgInput" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="插入中,请稍候">点击上传</el-button>
        </el-upload>
        <div slot="footer">
          <!--<Button type="primary" size="large" @click="openPreview">预览</Button>-->
          <Button type="primary" size="large" :loading="loadingInsert" @click="saveData">保存</Button>
        </div>
      <!--</Modal>-->

    </div>
  </div>
</template>
<script>
  import * as Quill from 'quill'
  import { quillEditor } from 'vue-quill-editor'

  var fonts = ['SimSun', 'SimHei', 'Microsoft-YaHei', 'KaiTi', 'FangSong', 'Arial', 'Times-New-Roman', 'sans-serif']
  var Font = Quill.import('formats/font')
  Font.whitelist = fonts
  Quill.register(Font, true)

  export default {
    components: {
      quillEditor,
    },
    name: 'BonusAndDeduction',
    data () {
      return {
        headers: {},
        uploadType: '',
        loadingInsert: false,
        fullscreenLoading: false,
        action: this.$appConfig.baseUrl + '/upload/fileUpload',
        acceptType: '',
        formData: {
          content: '',
          id: null
        },
        options: {
        },
        editorOption: {
          modules: {
            toolbar: {
              container: [
                ['bold', 'italic', 'underline', 'strike'],
                ['blockquote', 'code-block'],
                [{'header': 1}, {'header': 2}],
                [{'list': 'ordered'}, {'list': 'bullet'}],
                [{'indent': '-1'}, {'indent': '+1'}],
                [{'size': ['small', false, 'large', 'huge']}],
                [{'header': [1, 2, 3, 4, 5, 6, false]}],
                [{'color': []}, {'background': []}],
                [{'align': []}],
                [{ 'font': fonts }],
                ['clean'],
                ['link', 'image', 'video']
              ],
            },
          }
        }
      }
    },
    methods: {
      textChange (val) {
        localStorage.setItem('bonusAndDeduction', this.formData.content)
      },
      beforeUpload (file) {
        if (file) {
          let names = file.name.split('.')
          if (names.length > 0 && names[names.length - 1] === 'mp3') {
            this.uploadType = 'audio'
          }
        }
        this.fullscreenLoading = true
        this.headers.token = this.$store.get('token')
        if (this.$store.get('account') && this.$store.get('password')) {
          this.headers.account = this.$store.get('account')
          this.headers.password = this.$store.get('password')
        }
      },
      // 点击图片ICON触发事件
      imgHandler (state) {
        this.uploadType = 'image'
        this.addRange = this.$refs.myQuillEditor.quill.getSelection()
        if (state) {
          let fileInput = document.getElementById('imgInput')
          fileInput.click() // 加一个触发事件
        }
      },
      // 点击视频ICON触发事件
      videoHandler (state) {
        this.uploadType = 'video'
        this.addRange = this.$refs.myQuillEditor.quill.getSelection()
        if (state) {
          let fileInput = document.getElementById('imgInput')
          fileInput.click() // 加一个触发事件
        }
      },
      // 图片上传成功回调   插入到编辑器中
      upScuccess (e, file, fileList) {
        let self = this
        let response = file.response.data
        if (!response || !response.url) {
          this.$Message.error(`${self.uploadType}插入失败`)
          this.fullscreenLoading = false
          return
        }
        let url = response.url
        if (url != null && url.length > 0) {  // 将文件上传后的URL地址插入到编辑器文本中
          self.addRange = self.$refs.myQuillEditor.quill.getSelection()
          let index = self.addRange != null ? self.addRange.index : 0
          self.$refs.myQuillEditor.quill.insertEmbed(index, self.uploadType, url, 'user') // 调用编辑器的 insertEmbed 方法，插入URL
          this.fullscreenLoading = false
        } else {
          this.$Message.error(`${self.uploadType}插入失败`)
          this.fullscreenLoading = false
        }
        self.uploadType = ''
        this.$refs['upload'].clearFiles()
      },
      openPreview () {
        let url = '/#/course/lessonPreview'
        window.open(url)
      },
      saveData () {
        let self = this
        self.loadingInsert = true
        self.$http.post('/tch/updateBonusDeduction', this.formData).then(function (res) {
          if (res.data > 0) {
            self.$Message.success('保存成功!')
            self.loadData()
            self.loadingInsert = false
          }
        }).catch(function (e) {
          self.loadingInsert = false
        })
      },
      loadData () {
        let self = this
        self.$http.get('/tch/getBonusDeductionList').then(function (res) {
          if (res.data) {
            self.formData = res.data
          }
        })
      }
    },
    mounted () {
      // 为图片ICON绑定事件  getModule 为编辑器的内部属性
      this.$refs.myQuillEditor.quill.getModule('toolbar').addHandler('image', this.imgHandler)
      this.$refs.myQuillEditor.quill.getModule('toolbar').addHandler('video', this.videoHandler)  // 为视频ICON绑定事件
    },
    created: function () {
      this.loadData()
    }
  }
</script>



// WEBPACK FOOTER //
// BonusAndDeduction.vue?e08ba9de